import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M0 1.5A.75.75 0 0 1 .75.75h22.5a.75.75 0 0 1 0 1.5c-.188 0-.47.111-.841.492-.36.37-.72.911-1.054 1.554-.667 1.283-1.152 2.816-1.33 3.754l-.93 4.898a.75.75 0 0 1-1.472.006L16.442 7.01l-3.209 15.394a.75.75 0 0 1-1.468.001L8.977 9.154l-1.62 9.055a.75.75 0 0 1-1.476-.001L3.907 7.121c-.123-.605-.686-1.878-1.423-3.028-.364-.567-.745-1.063-1.097-1.407-.158-.154-.4-.411-.637-.436A.75.75 0 0 1 0 1.5m3.008.75c.26.321.508.674.738 1.034.781 1.218 1.46 2.68 1.633 3.55l.003.016 1.24 6.958 1.382-7.73c.186-1.04 1.658-1.044 1.856-.015l2.635 12.528 2.888-13.853a1.08 1.08 0 0 1 1.064-.895c.488 0 .958.331 1.072.89v.004l.823 4.138.21-1.104c.203-1.077.735-2.75 1.472-4.167.248-.477.528-.943.838-1.354z"
      clipRule="evenodd"
    />
  </>
);

const TrailIcy = Icon('trail-icy', svgContents);

export default TrailIcy;
